import { t as tr } from "../../lib/i18n";
import { Icon } from "../../ui/Icon";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api, errorMessage } from "../../lib/api";
import { Alert } from "../../components/Form";
import { Screen, StudyGate, TopBar, levelName, titleCase, useLang } from "./kit";

type Unit = {
  id: string; titleMs: string; titleEn: string | null; emoji: string | null; theme: string | null; ready: boolean;
  lessons: number; lessonsDone: number; questions: number; mastery: number | null; tp: number | null;
};
type Data = { subject: { versionId: string; level: string; year: number; subject: string; nameMs: string; nameEn: string }; units: Unit[] };


export function SubjectPage() {
  return (
    <Screen>
      <StudyGate>
        <Inner />
      </StudyGate>
    </Screen>
  );
}

function Inner() {
  const { versionId = "" } = useParams();
  const { pick, lang } = useLang();
  const [data, setData] = useState<Data | null>(null);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    api<Data>(`/api/learn/subject/${versionId}`).then(setData).catch((e) => setError(errorMessage(e)));
  }, [versionId]);

  const s = data?.subject;
  return (
    <>
      <TopBar
        back={s ? `/belajar/${s.level}/${s.year}` : "/belajar"}
        title={s ? (lang === "en" ? s.nameEn || s.nameMs : tr(s.nameMs)) : "…"}
        {...(s ? { subtitle: `${levelName(s.level, s.year)} · ${data!.units.filter((u) => u.ready).length} ${tr("unit")}` } : {})}
      />
      {error && <Alert kind="error">{error}</Alert>}
      <ul className="space-y-3">
        {(data?.units ?? []).map((u, i) => {
          const complete = u.ready && u.lessons > 0 && u.lessonsDone === u.lessons;
          const row = (
            <div className={`flex items-center gap-3 rounded-3xl bg-card p-4 shadow-sm ring-1 ring-black/5 ${u.ready ? "transition hover:-translate-y-0.5" : "opacity-50"}`}>
              <span className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl bg-amber-50 text-2xl"><Icon name="book" className="h-6 w-6 text-amber-500" /></span>
              <div className="min-w-0 flex-1">
                <p className="text-[11px] font-bold uppercase tracking-wide text-slate-400">
                  Unit {i + 1}
                  {u.theme && <span className="ml-2 rounded-full bg-rose-50 px-2 py-0.5 normal-case tracking-normal text-rose-500">{titleCase(u.theme)}</span>}
                </p>
                <p className="truncate font-extrabold text-slate-900">{pick(titleCase(u.titleMs), u.titleEn)}</p>
                {lang === "en" && u.titleEn && <p className="truncate text-xs text-slate-400">{titleCase(u.titleMs)}</p>}
                {!u.ready && <p className="text-xs text-slate-400">{tr("Akan datang")}</p>}
              </div>
              {u.ready && (
                <div className="flex shrink-0 flex-col items-end gap-1 text-xs font-semibold">
                  <span className={complete ? "text-emerald-600" : "text-slate-400"}>{complete ? "✔ " : ""}{u.lessonsDone}/{u.lessons}</span>
                  {u.mastery !== null && <span className="rounded-full bg-violet-50 px-2 py-0.5 text-violet-600">{u.mastery}%</span>}
                </div>
              )}
            </div>
          );
          return <li key={u.id}>{u.ready ? <Link to={`/belajar/unit/${u.id}`}>{row}</Link> : row}</li>;
        })}
      </ul>
    </>
  );
}
